/*
 * Carrousels de la page d'accueil (sections/lns-home-carrousel.liquid et
 * sections/lns-home-collections.liquid, repérée par data-lns-carrousel).
 * Une flèche fait défiler d'une largeur visible. Aux extrémités, la flèche est
 * marquée aria-disabled (et non disabled) : elle reste la cible du clic, qui est
 * absorbé. Avec l'attribut disabled, certains navigateurs (Safari) laissaient
 * le clic atteindre un autre gestionnaire de la page. Le script peut être chargé plusieurs fois (une fois par
 * section) : il ne s'initialise qu'une fois, et chaque carrousel une seule fois,
 * y compris dans l'éditeur de thème (shopify:section:load).
 */
(function () {
  'use strict';
  if (window.__lnsHomeCarrousel) return;
  window.__lnsHomeCarrousel = true;

  function step(track) {
    return Math.max(1, Math.round(track.clientWidth * 0.9));
  }

  function majFleches(root, track) {
    var max = track.scrollWidth - track.clientWidth - 2;
    var prev = root.querySelector('[data-lns-dir="-1"]');
    var next = root.querySelector('[data-lns-dir="1"]');
    if (prev) prev.setAttribute('aria-disabled', track.scrollLeft <= 2 ? 'true' : 'false');
    if (next) next.setAttribute('aria-disabled', track.scrollLeft >= max ? 'true' : 'false');
  }

  function init(root) {
    if (!root || root.__lnsInit) return;
    var track = root.querySelector('.lns-car__track');
    if (!track) return;
    root.__lnsInit = true;
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-lns-dir]');
      if (!btn || !root.contains(btn)) return;
      e.preventDefault();
      e.stopPropagation();
      if (btn.getAttribute('aria-disabled') === 'true') return;
      var dir = parseInt(btn.getAttribute('data-lns-dir'), 10) || 1;
      track.scrollBy({ left: dir * step(track), behavior: 'smooth' });
    });
    var raf = 0;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = window.requestAnimationFrame(function () {
        raf = 0;
        majFleches(root, track);
      });
    }, { passive: true });
    window.addEventListener('resize', function () { majFleches(root, track); });
    majFleches(root, track);
  }

  function initAll(scope) {
    var list = (scope || document).querySelectorAll('[data-section-type="lns-home-carrousel"], [data-lns-carrousel]');
    for (var i = 0; i < list.length; i++) init(list[i]);
  }

  window.LnsHomeCarrousel = { init: init, initAll: initAll, step: step, majFleches: majFleches };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
